<template>
  <modal :open="open" @close="closeModal" :title="title" :close-label="closeLabel" :size="size">
    <slot/>
  </modal>
</template>

<script>
import Vue from "vue";
import HashUtil from "../plugins/hash-util";

Vue.use(HashUtil);

export default {
  name: "hash-modal",
  props: {
    "hash": {
      type: String,
      required: true
    },
    "title": {
      type: String,
      default: ""
    },
    "closeLabel": {
      type: String,
      default: ""
    },
    "size": {
      type: String,
      default: ""
    }
  },
  data: function () {
    return {
      open: false,
      eager: false
    }
  },
  mounted: function () {
    this.eager = Vue.$hashUtil.contains(this.hash);
    if (this.eager) {
      this.openModal();
    }
    window.addEventListener("hashchange", this.handleHashChange);
  },
  beforeDestroy: function () {
    window.removeEventListener("hashchange", this.handleHashChange);
  },
  watch: {
    open: function (newValue) {
      if (newValue) {
        this.$emit("opening");
        this.$nextTick(() => {
          this.$emit("opened");
        });
      } else {
        this.$emit("closing");
        this.$nextTick(() => {
          this.$emit("closed");
        });
      }
    }
  },
  methods: {
    handleHashChange: function () {
      if (Vue.$hashUtil.contains(this.hash)) {
        this.openModal();
      } else {
        this.closeModal();
      }
    },
    openModal: function () {
      if (!Vue.$hashUtil.contains(this.hash)) {
        Vue.$hashUtil.add(this.hash);
      }
      this.open = true;
    },
    closeModal: function () {
      if (Vue.$hashUtil.contains(this.hash)) {
        Vue.$hashUtil.remove(this.hash);
      }
      this.open = false;
    }
  }
}
</script>
